import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

import { StoreContext } from '../../context/store';
import useProduct from '../../hooks/use_product';
import useTranslation from '../../hooks/use_translation';
import ProductList from '../test/product-list';

const Addons = ({
	exclude_products,
	product_id,
	product_settings,
	variant = 'slim',
}) => {
	const { countItems } = useContext(StoreContext);
	const { t } = useTranslation('component_shop_addons');
	let exclude_product_settings = [];

	if (
		product_settings &&
		Object.hasOwn(product_settings, 'include_statement') &&
		product_settings.include_statement != null
	) {
		exclude_product_settings.push('include_statement');
	}

	const { items: products } = useProduct({
		exclude_product_settings,
		exclude_product_states: ['affiliate'],
		exclude_products,
		has_markers: false,
		include_product_types: ['addon'],
	});
	const product_ids = useMemo(() => {
		let out = [];

		const product_1 = products
			.filter((item) => !item.products?.length)
			.map((item) => item?.product_id);
		const product_2 = products
			.filter((item) => item.products.includes(product_id))
			.map((item) => item?.product_id);

		out = [...new Set([...product_1, ...product_2])];

		return out;
	}, [product_id, products]);

	if (!countItems || !product_ids?.length) {
		return;
	}

	return (
		<ProductList
			grouping={false}
			include_products={product_ids}
			page="vardtjanster"
			tracking={{ item_list_name: 'Addon products', source: 'addon' }}
			variant={variant}
		>
			{(component) => (
				<>
					{component && (
						<>
							<h3 className="accordion-button-fake fw-800 mb-0">{t('t1')}</h3>
							{component}
						</>
					)}
				</>
			)}
		</ProductList>
	);
};

Addons.propTypes = {
	exclude_products: PropTypes.array,
	product_id: PropTypes.number,
	product_settings: PropTypes.object,
	variant: PropTypes.string,
};

export default Addons;
